<template>
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
  >
    <path d="M9.5 0C10.8807 0 12 1.11929 12 2.5V4.25716C11.0491 3.47182 9.82963 3 8.5 3H11V2.5C11 1.67157 10.3284 1 9.5 1H2.5C1.67157 1 1 1.67157 1 2.5V3H8.5C7.32259 3 6.23159 3.36997 5.33692 4H1V9.5C1 10.3284 1.67157 11 2.5 11H3.59971C3.78261 11.3578 4.00353 11.6929 4.25716 12H2.5C1.11929 12 0 10.8807 0 9.5V2.5C0 1.11929 1.11929 0 2.5 0H9.5ZM8.5 13C10.9853 13 13 10.9853 13 8.5C13 6.01472 10.9853 4 8.5 4C6.01472 4 4 6.01472 4 8.5C4 10.9853 6.01472 13 8.5 13ZM8 6.5C8 6.22386 8.22386 6 8.5 6C8.77614 6 9 6.22386 9 6.5V8H10C10.2761 8 10.5 8.22386 10.5 8.5C10.5 8.77614 10.2761 9 10 9H8.5C8.22386 9 8 8.77614 8 8.5V6.5Z" />
  </svg>
</template>
